import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LicenseUserAvatarTooltipPipe } from './license-user-avatar-tooltip.pipe';

@NgModule({
  declarations: [LicenseUserAvatarTooltipPipe],
  imports: [CommonModule],
  exports: [LicenseUserAvatarTooltipPipe]
})
export class LicenseUserAvatarTooltipModule { }
